import clsx from "clsx";
import {KTIcon} from "../../../../../_metronic/helpers";

type SquireIconWrapperProps = {
    wrapperClass: string;
    iconName: string;
    iconClass: string;
    style?:Object
    onClick?:any
};
 const SquireIconWrapper = ({
  wrapperClass,
  iconName,
  iconClass,
     style,
     onClick
}: SquireIconWrapperProps) => {
  return (
    <div
      className={clsx(
        "border-ra-6-c d-flex justify-content-center align-items-center",
        wrapperClass,
      )}
      style={{ width: "32px", height: "32px",...style }}
      onClick={onClick}
    >
      <KTIcon iconName={iconName} className={clsx(iconClass.includes('fs-')?"":"fs-5", iconClass)} />
    </div>
  );
};

 export  default SquireIconWrapper
